import React, { useEffect, useRef } from 'react';
import { SeasonTab } from '@/types';

const tabs: Array<{ value: SeasonTab; label: string }> = [
  { value: 'overview', label: 'Overview' },
  { value: 'standings', label: 'Standings' },
  { value: 'team', label: 'Team analysis' },
  { value: 'players', label: 'Players' },
  { value: 'monthly', label: 'Monthly' },
];

const SeasonTabs: React.FC<{ value: SeasonTab; onChange(tab: SeasonTab): void }> = ({ value, onChange }) => {
  const buttons = useRef<Partial<Record<SeasonTab, HTMLButtonElement | null>>>({});
  const previous = useRef(value);
  useEffect(() => {
    if (previous.current !== value) buttons.current[value]?.focus();
    previous.current = value;
  }, [value]);
  const select = (index: number) => {
    const next = tabs[(index + tabs.length) % tabs.length].value;
    onChange(next);
    buttons.current[next]?.focus();
  };
  return <div className="overflow-x-auto border-b border-gray-200 dark:border-gray-700">
    <div role="tablist" aria-label="Season sections" className="flex min-w-max gap-1">
      {tabs.map((tab, index) => <button
        key={tab.value}
        ref={element => { buttons.current[tab.value] = element; }}
        id={`season-tab-${tab.value}`}
        type="button"
        role="tab"
        tabIndex={value === tab.value ? 0 : -1}
        aria-selected={value === tab.value}
        aria-controls={`season-panel-${tab.value}`}
        onClick={() => onChange(tab.value)}
        onKeyDown={event => {
          if (event.key === 'ArrowRight') { event.preventDefault(); select(index + 1); }
          else if (event.key === 'ArrowLeft') { event.preventDefault(); select(index - 1); }
          else if (event.key === 'Home') { event.preventDefault(); select(0); }
          else if (event.key === 'End') { event.preventDefault(); select(tabs.length - 1); }
        }}
        className={`min-h-11 border-b-2 px-4 text-sm font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-club-blue-500 ${value === tab.value ? 'border-club-blue-600 text-club-blue-700 dark:border-blue-400 dark:text-blue-300' : 'border-transparent text-gray-600 hover:border-gray-300 hover:text-gray-950 dark:text-gray-300 dark:hover:text-white'}`}
      >{tab.label}</button>)}
    </div>
  </div>;
};

export default SeasonTabs;
